// Course
export const GET_COURSES = 'getCourses';
export const GET_ALL_COURSE_RUN_DEMANDS = 'getCoursesRunDemands';
export const GET_COURSE_ITEM = 'getCourseItem';
export const ERROR_COURSE = 'errorCourse';
export const ERROR_COURSE_RUN_DEMANDS = 'errorCourseRunDemands';
export const ERROR_MY_COURSE_RUN_DEMANDS = 'errorCourseRunDemands';
export const SET_LOADING_COURSE = 'setLoadingCourse';
export const SET_PRE_REQUISITE_LOADING = 'set_pre_requisite_loading';
export const SET_COURSE_ITEM = 'setCourseItem';
export const UPDATE_COURSE_ITEM = 'updateCourseItem';
export const SEARCH_COURSES = 'searchCourses';
export const SET_LOADING_ALL_COURSE_RUN_DEMANDS = 'setLoadingCourseRunDemands';
export const GET_COURSE_RUN_DEMAND = 'getCoursesRunDemandDetail';
export const SET_COURSE_RUN_DEMAND_ACCEPTED = 'setCoursesRunDemandAccepted';
export const SET_COURSE_RUN_DEMAND_REJECTED = 'setCoursesRunDemandRejected';
export const SET_LOADING_ALL_MY_COURSE_RUN_DEMANDS = 'setLoadingCourseRunDemands';
export const GET_ALL_MY_COURSE_RUN_DEMANDS = 'getAllMyCoursesRunDemandDetail';

export const SET_LOADING_COURSE_IMAGE_FILE = 'setLoadingCourseImageFile';
export const SET_LOADING_COURSE_VIDEO_FILE = 'setLoadingCourseVideoFile';
export const UPDATE_COURSE_IMAGE_FILE = 'updateCourseImageFile';
export const UPDATE_COURSE_VIDEO_FILE = 'updateCourseVideoFile';
export const ERROR_COURSE_FILE_DATA = 'errorCourseFileData';

// Organization
export const GET_ORGANIZATIONS = 'getCourses';
export const GET_SINGLE_ORGANIZATIONS = 'getSingleOrganizations';
export const GET_DEMANDS_ORGANIZATIONS = 'getDemandsOrganization';
export const GET_SINGLE_DEMANDS_ORGANIZATIONS = 'getSingleDemandsOrganization';
export const GET_ORGANIZATIONS_HAS_ROLE = 'getOrganizationsHasRole';
export const GET_ORGANIZATIONS_IS_COURSE_CREATOR = 'getOrganizationsIsCourseCreator';
export const GET_ORGANIZATIONS_SEND_REQUEST = 'getOrganizationsSendRequest';
export const GET_ORGANIZATIONS_IS_ADMIN = 'getOrganizationsIsAdmin';
export const GET_ORGANIZATION_ITEM = 'getCourseItem';
export const ERROR_ORGANIZATION = 'errorCourse';
export const SET_LOADING_ORGANIZATION = 'setLoadingOrganization';
export const SET_ORGANIZATION_ITEM = 'setOrganizationItem';
export const UPDATE_DEMAND_ORGANIZATION_ITEM = 'updateDemandOrganizationItem';
export const UPDATE_ORGANIZATION_ITEM = 'updateOrganizationItem';
export const GET_ORGANIZATION_TEACHERS = 'getOrganizationTeachers';
export const UPDATE_ORGANIZATION_TEACHERS = 'updateOrganizaionTeachers';

// Instructor
export const GET_INSTRUCTOR_ITEM = 'getInstructorItem';
export const SET_INSTRUCTOR_ITEM = 'setInstructorItem';
export const UPDATE_INSTRUCTOR_ITEM = 'updateInstructorItem';
export const ERROR_INSTRUCTOR = 'errorInstructor';
export const SET_LOADING_INSTRUCTOR = 'setLoadingInstructor';

// Notification
export const GET_NOTIFS = 'getNotif';
export const SET_LOADING_NOTIF = 'setLoadingNotif';
export const GET_NOTIF_ITEM = 'getNotifItem';
export const ERROR_NOTIF = 'errorNotif';

// All Requests
export const GET_ALL_REQUESTS = 'getAllRequests';
export const SET_LOADING_ALL_REQUESTS = 'setLoadingAllRequests';
export const ERROR_ALL_REQUESTS = 'errorAllRequests';

// Organizations per Instructor
export const SET_ORGS_PER_INSTRUCTOR = 'updateOrgsPerInstructor';
export const UPDATE_ORG_INSTRUCTOR = 'updateOrgInstructor';
export const SET_LOADING_ORGS_PER_INSTRUCTOR = 'setLoadingOrgsPerInstructor';
export const ERROR_ORGS_PER_INSTRUCTOR = 'errorOrgsPerInstructor';

// User
export const GET_SEARCH_USERS = 'getSearchUsers';
export const SET_LOADING_USER = 'setLoadingUser';
export const ERROR_USER = 'errorUser';

// Settings
export const GET_ALL_SETTINGS = 'getAllSettings';
export const SET_LOADING_SETTINGS = 'setLoadingSettings';
export const ERROR_SETTINGS = 'errorSettings';

// Permission
export const GET_ALL_PERMISSIONS = 'getAllPermissions';
export const USER_INFO = 'userInfo';
export const SET_LOADING_PERMISSION = 'setLoadingPermission';
export const ERROR_PERMISSION = 'errorPermission';
export const SET_SELECTED_ROLE = 'setSelectedRole';
export const SET_SELECTED_ORG = 'setSelectedOrg';

// LevelType
export const GET_ALL_LEVEL_TYPES = 'getAllLevelTypes';
export const SET_LOADING_ALL_LEVEL_TYPES = 'setLoadingAllLevelTypes';
export const ERROR_ALL_LEVEL_TYPES = 'errorAllLevelTypes';

// Language
export const GET_ALL_LANGUAGES = 'getAllLanguages';
export const SET_LOADING_ALL_LANGUAGES = 'setLoadingAllLanguages';
export const ERROR_ALL_LANGUAGES = 'errorAllLanguages';

// SET_ERRORS
export const SET_GENERAL_ERROR = 'setGeneralError';
export const DELETE_GENERAL_ERROR = 'deleteGeneralError';
